import { AnyARecord } from "node:dns";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";

export async function UpdateOutletApprovalData(requestBody: any, approvalRequestId: string){
  const response = await ChannelkartNetworkPost(`/approval/approve/${approvalRequestId}`, requestBody);
  return response
}

export async function getViewOutletData(outletID:string, transformerName: string){
    const response = await ChannelkartNetworkGet(`/outletDetails/outletApprovalInfo?transformerout=${transformerName}&filter=id:${outletID}`)
    return response;
}

export async function getViewExistingOutletData(outletID:string, startDate: string, endDate: string){
  const response = await ChannelkartNetworkGet(
    `/v1/query/outletEntityApproval?fromDate=${startDate}&toDate=${endDate}&sort=creationTime:desc&minimalResponse=true`);
  return response;
}


export async function getOutletAccountInfo(outletId: string){
  const response = await ChannelkartNetworkGet(
    `/v1/accountInfo?filter=loginId:${outletId}`
  )
  return response;
}


export async function getOutletCreditInfo(outletId: string){
  const response = await ChannelkartNetworkGet(
    `/creditStatus?filter=loginId:${outletId}`
  )
  return response;
}

export const getApprovalRejectionRequestBody = (outletId: string, approver: string, status: string, remarks?: string) => {
  return {
    status,
    remarks
  };
}

export async function getApprovalRequestId(referenceId: string){
  const response = await ChannelkartNetworkGet(
    `/approval/${referenceId}`
  );
  return response;
};
